import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../Actions/bankfeeds';
import { Button } from '@material-ui/core';


import css from './bfm.css';

class SissFeed extends Component {

    state = { sissStarted: false };

    componentDidMount() {
       this.props.getSissURL();
     }

     onSissSignup(URL) {
      window.open(URL, '_blank');
      setTimeout(() => this.setState({ sissStarted: true }), 1000);

     }

    componentWillUnmount() {
      this.props.clearSissURL();
    }


     render() {
      const { bankfeeds, onCompleted, onClose } = this.props;
      const URL = bankfeeds && bankfeeds.sissURL;

        if (this.state.sissStarted) {
          return (
            <div className={css.w600}>
                <div className={css.pb20}>
                <p className={css.formatText}>
                  Open Banking feeds that have been successfully added will show on this screen. please link your new feeds to the bank accounts in your Reckon products to start using them.
                </p>
                </div>

                <div className={[css.pb10, css.dividerDarkGrey].join(' ')}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={[css.mr10, css.floatRight].join(' ')}
                    onClick={onCompleted}>Close</Button>
                </div>
              </div>
            );
        }

        return (
            <div className={css.w600}>
              <div className={css.pb20}>
                <p className={css.formatText}>Open banking is the most secure form of bank feed. It allows instant access to your bank transactions in 
                Reckon One with no waiting or need for paper forms.</p>
                <p className={css.formatText}>
                Reckon partners with SISS Data Services, Australia’s leading independent provider 
                of secure banking and financial data services, to provide this service.
                </p>
                <p className={css.formatText}>
                  <a rel='noopener noreferrer' className={css.ml5} target='_blank' href='https://help.reckon.com/article/ck6giage4e-adding-an-open-banking-feed-in-reckon-one'>
                    Read more about setting up an open banking feed
                  </a>
                </p>
              </div>
              <div className={[css.pb10, css.dividerDarkGrey].join(' ')}>
                <Button type='button' variant='contained' onClick={onClose}>Close</Button>
                <Button
                  variant='contained'
                  className={[css.mr10, css.floatRight].join(' ')}
                  color='primary'
                  disabled={!URL}
                  onClick={() => this.onSissSignup(URL)}>{URL ? 'Continue' : 'Connecting...'}</Button>
              </div>
            </div>
        );
     }

    }

function mapStateToProps({ bankfeeds }) {
    return bankfeeds;
}
      
export default connect(mapStateToProps, actions)(SissFeed);
    


// WEBPACK FOOTER //
// ./src/components/FeedManagment/SissFeed.js